module.exports = __webpack_public_path__ + "img/ic_send_audio.cf02ca3d.png";